module.exports = __webpack_public_path__ + "static/media/project-bg.0ca557d4.png";